import React from 'react'
import PropTypes from 'prop-types'

const PageHero = ({ title, small }) =>
  <div
    css={{
      minHeight: '60vh',
      position: 'relative',
    }}
  >
    <div
      css={{
        left: '50%',
        position: 'absolute',
        textAlign: 'center',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
      }}
    >
      <h1
        css={{
          fontFamily: 'Lemon Tuesday',
          fontSize: '2.2rem',
          letterSpacing: 1.8,
        }}
      >
        {title}
        {small && <small
          css={{
            color: '#b8b8b8',
            display: 'block',
            fontFamily: 'Raleway, Open Sans',
            fontSize: '.4em',
            marginTop: '2rem',
            textTransform: 'uppercase',
          }}
        >
          {small}
        </small>}
      </h1>
    </div>
  </div>

PageHero.defaultProps = {
  small: false,
}

PageHero.prototype = {
  title: PropTypes.string.isRequired,
  small: PropTypes.string,
}

export default PageHero



// WEBPACK FOOTER //
// ./src/components/PageHero.js